export default __webpack_public_path__ + "static/media/editar.48f4ceef.ico";